/* eslint-disable react/jsx-props-no-spreading */
import React, { ComponentProps } from 'react';

import InputBaseMaterial from '@material-ui/core/InputBase';

import classes from './inputBase.module.scss';

export interface InputProps extends ComponentProps<typeof InputBaseMaterial> {
  dataTestId?: string | null;
}

/**
 * @see https://v4.mui.com/api/input-base/
 */
const InputBase = (props: InputProps) => {
  const { dataTestId, ...rest } = props;
  return (
    <InputBaseMaterial
      classes={{
        root: classes.root,
        input: classes.input,
      }}
      {...rest}
      data-testid={dataTestId}
    />
  );
};

export default InputBase;
